module.exports = __webpack_public_path__ + "img/Zappier_mobile-screenshot.e350fcbb.png";